import Vue from 'vue'
import VueRouter from 'vue-router'
import API from './http-common.js'
import config from './config'

//layout
import Layout from './components/Layout/Layout.vue'

//account
import Login from './components/Account/Login.vue'
import ForgotPassword from './components/Account/ForgotPassword.vue'
import PasswordChange from './components/Account/ChangePassword.vue'
import Administrators from './components/Account/Administrators.vue'
import Dashboard from './components/Account/Dashboard.vue'
import Home from './components/Account/Home.vue'

//insurance
import InsuranceType from './components/Insurance/InsuranceType.vue'
import EnrolmentCategory from './components/Insurance/EnrolmentCategory.vue'
import InsuranceCategoryMapping from './components/Insurance/InsuranceCategoryMapping.vue'
import InsuranceDependent from './components/Insurance/InsuranceAndDependent/Layout.vue'
import InsuranceDependentInsuranceEdit from './components/Insurance/InsuranceAndDependent/InsuranceEdit.vue'
import InsuranceDependentDependentEdit from './components/Insurance/InsuranceAndDependent/DependentEdit.vue'
import InsuranceReport from './components/Insurance/Report.vue'
import InsuranceChangesReport from './components/Insurance/ChangesReport.vue'

//benefit
import Group from './components/Benefit/Group.vue'
import BenefitOption from './components/Benefit/BenefitOption.vue'
import BenefitItem from './components/Benefit/BenefitItem.vue'
import BenefitOptionItemMapping from './components/Benefit/BenefitOptionItemMapping.vue'
import EmployeeBenefitOptionList from './components/Benefit/EmployeeBenefitOption/EmployeeBenefitOptionList.vue'
import EmployeeBenefitOptionEdit from './components/Benefit/EmployeeBenefitOption/EmployeeBenefitOptionEdit.vue'
import BenefitReport from './components/Benefit/Report.vue'

//attendance
import Timesheet from './components/Attendance/Timesheet.vue'
import TimesheetList from './components/Attendance/List.vue'
import PendingTimesheetList from './components/Attendance/PendingList.vue'
import CADOImport from './components/Attendance/CADOImport.vue'
import CADOImportDetail from './components/Attendance/CADOImportDetail.vue'
import MonthlyOvertimeReport from './components/Attendance/MonthlyOvertimeReport.vue'
import MyMonthlyOvertimeReport from './components/Attendance/MyMonthlyOvertimeReport.vue'
import MonthlyOvertimeStandbyShiftAllowanceReport from './components/Attendance/MonthlyOvertimeStandbyShiftAllowanceReport.vue'
import MyMonthlyOvertimeStandbyShiftAllowanceReport from './components/Attendance/MyMonthlyOvertimeStandbyShiftAllowanceReport.vue'
import CADOLog from './components/Attendance/CADOLog.vue'
import CADONotificationRecipient from './components/Attendance/CADONotificationRecipient.vue'
import ApplicableLeaveType from './components/Attendance/ApplicableLeaveType.vue'

//carpark
import PendingCarParkClaimList from './components/Carpark/PendingList.vue'
import MyCarParkClaim from './components/Carpark/MyCarParkClaim.vue'
import CarParkClaimForm from './components/Carpark/CarParkClaimForm.vue'
import ViewCarParkClaim from './components/Carpark/ViewCarParkClaim.vue'
import MyStaffCarParkClaim from './components/Carpark/MyStaffCarParkClaim.vue'
import MonthlyCarParkClaimReport from './components/Carpark/MonthlyCarParkClaimReport.vue'

//corporate pass
import ManageCorporatePass from './components/Corppass/ManageCorporatePass.vue'
import ManageCorporatePassDetail from './components/Corppass/ManageCorporatePassDetail.vue'
import ManagePassBlockingDate from './components/Corppass/ManagePassBlockingDate.vue'
import ManagePassBlockingDateDetail from './components/Corppass/ManagePassBlockingDateDetail.vue'
import ManagePassOption from './components/Corppass/ManagePassOption.vue'
import ManagePassBookingHistory from './components/Corppass/ManagePassBookingHistory.vue'
import BookingDetail from './components/Corppass/BookingDetail.vue'
import SubmitCorporatePass from './components/Corppass/SubmitCorporatePass.vue'

//leave of absence
import ManageLeaveName from './components/Leave/ManageLeaveName.vue'
import ViewLeaveOfAbsence from './components/Leave/ViewLeaveOfAbsence.vue'
import MyLeaveOfAbsence from './components/Leave/MyLeaveOfAbsence.vue'
import MyStaffLeaveOfAbsence from './components/Leave/MyStaffLeaveOfAbsence.vue'
import ViewLeaveOfAbsenceReport from './components/Leave/ViewLeaveOfAbsenceReport.vue'
import MyLeaveOfAbsenceReport from './components/Leave/MyLeaveOfAbsenceReport.vue'
import MyStaffLeaveOfAbsenceReport from './components/Leave/MyStaffLeaveOfAbsenceReport.vue'

//leave utilization report
import AdminLeaveUtilizationReport from './components/LeaveUtilizationReport/AdminLeaveUtilizationReport.vue'
import ManageShutdownCarryForward from './components/LeaveUtilizationReport/ManageShutdownCarryForward.vue'
import MyLeaveUtilizationReport from './components/LeaveUtilizationReport/MyLeaveUtilizationReport.vue'
import MyStaffLeaveUtilizationReport from './components/LeaveUtilizationReport/MyStaffLeaveUtilizationReport.vue'

//oil and ot report
import OILAndOTReport from './components/OILAndOTReport/OILAndOTReport.vue'

//sytem
import Option from './components/System/Option.vue'
import Settings from './components/System/Settings.vue'
import OvertimePaymentCalculation from './components/System/OvertimePaymentCalculation.vue'
import PublicHoliday from './components/System/PublicHoliday.vue'
import LeaveHoliday from './components/System/LeaveHoliday.vue'
import DelegationList from './components/System/Delegation/DelegationList.vue'
import DelegationEdit from './components/System/Delegation/DelegationEdit.vue'
import EmailLog from './components/System/EmailLog.vue'
import SyncLog from './components/System/SyncLog.vue'
import ReminderList from './components/System/Reminder/ReminderList.vue'
import ReminderEdit from './components/System/Reminder/ReminderEdit.vue'
import WorkCalendar from './components/System/WorkCalendar.vue'
import ShiftCode from './components/System/ShiftCode.vue'
import Menu from './components/System/Menu.vue'

//fwa
import FwaForm from './components/Fwa/FwaForm.vue'
import FwaSetup from './components/Fwa/FwaSetup.vue'
import FwaApprover from './components/Fwa/FwaApprover.vue'
import MyFwaRecord from './components/Fwa/MyFwaRecord.vue'
import MyStaffFwaRecord from './components/Fwa/MyStaffFwaRecord.vue'
import ManageFwaRecord from './components/Fwa/ManageFwaRecord.vue'
import FwaReport from './components/Fwa/FwaReport.vue'
import FwaPendingList from './components/Fwa/PendingList.vue'

//sso
import SSO from './components/Account/SSO.vue'

//page not found
import PageNotFound from './components/PageNotFound.vue'

Vue.use(VueRouter)
let appPath = config.APP_ROOT_PATH;

const routes = [
  { path: appPath + 'login', name: 'login', component: Login },
  { path: appPath + 'sso', name: 'sso', component: SSO },
  { path: appPath + 'forgotpassword', name: 'forgotPassword', component: ForgotPassword },
  {
    path: appPath, component: Layout, children: [
      { path: '', redirect: { name: 'home' } }, //default
      //insurance
      { path: 'insurancetype', name: 'insuranceType', component: InsuranceType },
      { path: 'enrolmentcategory', name: 'enrolmentCategory', component: EnrolmentCategory },
      { path: 'insurancecategorymapping', name: 'insuranceCategoryMapping', component: InsuranceCategoryMapping },
      { path: 'insurancedependent', name: 'insuranceDependent', component: InsuranceDependent },
      { path: 'insurancedependent/insurance/add', name: 'insuranceDependentInsuranceAdd', component: InsuranceDependentInsuranceEdit },
      { path: 'insurancedependent/insurance/:id', name: 'insuranceDependentInsuranceEdit', component: InsuranceDependentInsuranceEdit },
      { path: 'insurancedependent/dependent/add', name: 'insuranceDependentDependentAdd', component: InsuranceDependentDependentEdit },
      { path: 'insurancedependent/dependent/:id', name: 'insuranceDependentDependentEdit', component: InsuranceDependentDependentEdit },
      { path: 'insurancereport', name: 'insuranceReport', component: InsuranceReport },
      { path: 'insurancechangesreport', name: 'insuranceChangesReport', component: InsuranceChangesReport },
      //benefit
      { path: 'group', name: 'group', component: Group },
      { path: 'benefitoption', name: 'benefitOption', component: BenefitOption },
      { path: 'benefititem', name: 'benefitItem', component: BenefitItem },
      { path: 'benefitoptionitemmapping', name: 'benefitOptionItemMapping', component: BenefitOptionItemMapping },
      { path: 'employeebenefitoption', name: 'employeeBenefitOptionList', component: EmployeeBenefitOptionList },
      { path: 'employeebenefitoption/add', name: 'employeeBenefitOptionAdd', component: EmployeeBenefitOptionEdit },
      { path: 'employeebenefitoption/:id', name: 'employeeBenefitOptionEdit', component: EmployeeBenefitOptionEdit },
      { path: 'benefitreport', name: 'benefitReport', component: BenefitReport },
      //attendance
      { path: 'attendance/list/timesheet', name: 'timesheetList', component: TimesheetList },
      { path: 'attendance/list/pendingtimesheet', name: 'pendingTimesheetList', component: PendingTimesheetList },
      { path: 'attendance/import/cado', name: 'CADOImport', component: CADOImport },
      { path: 'attendance/cado/detail/:id', name: 'CADOImportDetail', component: CADOImportDetail },
      { path: 'attendance/timesheet', name: 'timesheet', component: Timesheet },
      { path: 'attendance/view/timesheet/:id', name: 'timesheetView', component: Timesheet },
      { path: 'attendance/report/timesheet/monthlyovertime', name: 'monthlyOvertimeReport', component: MonthlyOvertimeReport },
      { path: 'attendance/report/timesheet/mymonthlyovertime', name: 'myMonthlyOvertimeReport', component: MyMonthlyOvertimeReport },
      { path: 'attendance/report/timesheet/monthlyotstandbyshiftallowance', name: 'monthlyOvertimeStandbyShiftAllowanceReport', component: MonthlyOvertimeStandbyShiftAllowanceReport },
      { path: 'attendance/report/timesheet/mymonthlyotstandbyshiftallowance', name: 'myMonthlyOvertimeStandbyShiftAllowanceReport', component: MyMonthlyOvertimeStandbyShiftAllowanceReport },
      { path: 'attendance/log/cado', name: 'CADOLog', component: CADOLog },
      { path: 'attendance/notificationrecipient/cado', name: 'CADONotificationRecipient', component: CADONotificationRecipient },
      { path: 'attendance/applicableleavetype', name: 'applicableLeaveType', component: ApplicableLeaveType },
      //carpark
      { path: 'carpark/list/pendingcarparkclaim', name: 'pendingCarparkClaimList', component: PendingCarParkClaimList },
      { path: 'carpark/myclaim', name: 'myCarparkClaim', component: MyCarParkClaim },
      { path: 'carpark/claimform/:id', name: 'carparkClaimFormView', component: CarParkClaimForm },
      { path: 'carpark/viewclaims', name: 'carparkClaimView', component: ViewCarParkClaim },
      { path: 'carpark/mystaffcarparkclaim', name: 'myStaffCarparkClaim', component: MyStaffCarParkClaim },
      { path: 'carpark/monthlyclaimreport', name: 'monthlyCarparkClaimReport', component: MonthlyCarParkClaimReport },
      //corporate pass
      { path: 'corppass/manage', name: 'manageCorporatePass', component: ManageCorporatePass },
      { path: 'corppass/manage/add', name: 'manageCorporatePassAdd', component: ManageCorporatePassDetail },
      { path: 'corppass/manage/:id', name: 'manageCorporatePassEdit', component: ManageCorporatePassDetail },
      { path: 'corppass/blockingdate', name: 'managePassBlockingDate', component: ManagePassBlockingDate },
      { path: 'corppass/blockingdate/add', name: 'managePassBlockingDateAdd', component: ManagePassBlockingDateDetail },
      { path: 'corppass/blockingdate/:id', name: 'managePassBlockingDateEdit', component: ManagePassBlockingDateDetail },
      { path: 'corppass/setting', name: 'managePassOption', component: ManagePassOption },
      { path: 'corppass/bookinghistory', name: 'managePassBookingHistory', component: ManagePassBookingHistory },
      { path: 'corppass/booking/:id', name: 'bookingDetail', component: BookingDetail },
      { path: 'corppass/submit', name: 'submitCorporatePass', component: SubmitCorporatePass },
      //leave of absence
      { path: 'leave/manage', name: 'manageLeaveName', component: ManageLeaveName },
      { path: 'leave/view', name: 'viewLeave', component: ViewLeaveOfAbsence },
      { path: 'leave/myleave', name: 'myLeave', component: MyLeaveOfAbsence },
      { path: 'leave/mystaffleave', name: 'myStaffLeave', component: MyStaffLeaveOfAbsence },
      { path: 'leave/viewreport', name: 'viewLeaveReport', component: ViewLeaveOfAbsenceReport },
      { path: 'leave/myleavereport', name: 'myLeaveReport', component: MyLeaveOfAbsenceReport },
      { path: 'leave/mystaffleavereport', name: 'myStaffLeaveReport', component: MyStaffLeaveOfAbsenceReport },
      //fwa
      { path: 'fwa/form', name: 'fwaForm', component: FwaForm },
      { path: 'fwa/view/:id', name: 'fwaView', component: FwaForm },
      { path: 'fwa/setup', name: 'fwaSetup', component: FwaSetup },
      { path: 'fwa/approver', name: 'fwaApprover', component: FwaApprover },
      { path: 'fwa/my-fwa-record', name: 'fwaMyRecord', component: MyFwaRecord },
      { path: 'fwa/my-staff-fwa-record', name: 'fwaMyStaffRecord', component: MyStaffFwaRecord },
      { path: 'fwa/manage-fwa-record', name: 'fwaManageRecord', component: ManageFwaRecord },
      { path: 'fwa/report', name: 'fwaReport', component: FwaReport },
      { path: 'fwa/pending-list', name: 'fwaPendingList', component: FwaPendingList },
      //leave utilization report
      { path: 'leave-utilization-report/admin', name: 'adminLeaveUtilizationReport', component: AdminLeaveUtilizationReport },
      { path: 'leave-utilization-report/manage-shutdown-carry-forward', name: 'manageShutdownCarryForward', component: ManageShutdownCarryForward },
      { path: 'leave-utilization-report/my-report', name: 'myLeaveUtilizationReport', component: MyLeaveUtilizationReport },
      { path: 'leave-utilization-report/my-staff-report', name: 'myStaffLeaveUtilizationReport', component: MyStaffLeaveUtilizationReport },
      //oil and ot report
      { path: 'oilandotreport', name: 'oilAndOtReport', component: OILAndOTReport },
      //sytem
      { path: 'dashboard', name: 'dashboard', component: Dashboard },
      { path: 'option', name: 'option', component: Option },
      { path: 'settings', name: 'settings', component: Settings },
      { path: 'overtimepaymentcalculation', name: 'overtimepaymentcalculation', component: OvertimePaymentCalculation },
      { path: 'publicholiday', name: 'publicHoliday', component: PublicHoliday },
      { path: 'leaveholiday', name: 'leaveHoliday', component: LeaveHoliday },
      { path: 'delegation', name: 'delegationList', component: DelegationList },
      { path: 'delegation/add', name: 'delegationAdd', component: DelegationEdit },
      { path: 'delegation/:id', name: 'delegationEdit', component: DelegationEdit },
      { path: 'reminder', name: 'reminderList', component: ReminderList },
      { path: 'reminder/add', name: 'reminderAdd', component: ReminderEdit },
      { path: 'reminder/:id', name: 'reminderEdit', component: ReminderEdit },
      { path: 'emaillog', name: 'emailLog', component: EmailLog },
      { path: 'synclog', name: 'syncLog', component: SyncLog },
      { path: 'workcalendar', name: 'workCalendar', component: WorkCalendar },
      { path: 'shiftcode', name: 'shiftCode', component: ShiftCode },
      { path: 'menu', name: 'menu', component: Menu },

      { path: 'passwordchange', name: 'passwordChange', component: PasswordChange },
      { path: 'administrators', name: 'administrators', component: Administrators },
      { path: 'home', name: 'home', component: Home }
    ], beforeEnter(to, from, next) {
      if (from.name == 'login') return next();
      let data = JSON.parse(localStorage.getItem('lambitoken'))
      if (!data) return next({ name: 'login' })
      API.verifyToken({ Token: data.Token }).then(response => {
        if (response.data == false) {
          localStorage.removeItem('lambitoken')
          return next({ name: 'login' })
        } else {
          return next()
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'login' })
      })
    }
  },
  { path: '*', name: 'pageNotFound', component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router


// WEBPACK FOOTER //
// ./src/router.js